/* CozieSleep geo text v32: swaps [data-cz-geo] text to a US-state / Canadian-province string.
   One lookup per visitor (localStorage, 24h), 1.5s timeout, silent failure = generic text stays. */
(function () {
  if (window.__czGeo) return;
  window.__czGeo = true;
  var KEY = 'cz_geo_v1', TTL = 864e5, URL = 'https://get.geojs.io/v1/ip/geo.json';
  var OK_REGION = /^[A-Za-zÀ-ÿ .'\-]{2,40}$/;

  function store(k, v, s) { try { (s ? sessionStorage : localStorage).setItem(k, v); } catch (e) {} }
  function read(k, s) { try { return (s ? sessionStorage : localStorage).getItem(k); } catch (e) { return null; } }

  function lookup(cb) {
    try {
      var c = JSON.parse(read(KEY) || 'null');
      if (c && c.t && Date.now() - c.t < TTL) return cb(c);
    } catch (e) {}
    if (read(KEY + '_fail', true)) return cb(null);
    var done = false;
    function fin(g) { if (done) return; done = true; if (!g) store(KEY + '_fail', '1', true); cb(g); }
    try {
      var x = new XMLHttpRequest();
      x.open('GET', URL, true);
      x.timeout = 1500;
      x.onload = function () {
        try {
          if (x.status !== 200) return fin(null);
          var d = JSON.parse(x.responseText);
          var g = { t: Date.now(), cc: String(d.country_code || '').toUpperCase(), region: String(d.region || '').trim() };
          if (!g.cc) return fin(null);
          store(KEY, JSON.stringify(g));
          fin(g);
        } catch (e) { fin(null); }
      };
      x.onerror = x.ontimeout = x.onabort = function () { fin(null); };
      x.send();
      setTimeout(function () { if (!done) { try { x.abort(); } catch (e) {} fin(null); } }, 1600);
    } catch (e) { fin(null); }
  }

  function apply(g) {
    if (!g || (g.cc !== 'US' && g.cc !== 'CA') || !OK_REGION.test(g.region)) return;
    var els = document.querySelectorAll('[data-cz-geo]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-cz-geo-done') === g.cc + '|' + g.region) continue;
      var tpl = (el.getAttribute(g.cc === 'US' ? 'data-cz-geo-us' : 'data-cz-geo-ca') || '').trim();
      if (!tpl) continue;
      if (!el.hasAttribute('data-cz-geo-orig')) el.setAttribute('data-cz-geo-orig', el.textContent);
      var box = el.closest('[data-cz-geo-box]') || el.parentNode, h0 = box.offsetHeight;
      el.textContent = tpl.replace(/\{region\}/g, g.region);
      // no layout shift: if the longer text makes its box taller, keep the generic text
      if (box.offsetHeight > h0 + 1) { el.textContent = el.getAttribute('data-cz-geo-orig'); continue; }
      el.setAttribute('data-cz-geo-done', g.cc + '|' + g.region);
      var scope = el.closest('[data-cz-geo-scope]');
      if (scope) {
        var flags = scope.querySelectorAll('[data-cz-geo-flag]');
        var has = false;
        for (var j = 0; j < flags.length; j++) if (flags[j].getAttribute('data-cz-geo-flag') === g.cc) has = true;
        if (has) for (var k = 0; k < flags.length; k++) flags[k].hidden = flags[k].getAttribute('data-cz-geo-flag') !== g.cc;
      }
    }
  }

  var geo;
  function run() { lookup(function (g) { geo = g; apply(g); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', function () { if (geo) apply(geo); });
})();
